'use strict';

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var DirSharded = require('./dir-sharded');

module.exports = /*#__PURE__*/function () {
  var _flatToShard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(child, dir, threshold, options) {
    var newDir, parent;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newDir = dir;

            if (!(dir.flat && dir.directChildrenCount() >= threshold)) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return convertToShard(dir, options);

          case 4:
            newDir = _context2.sent;

          case 5:
            parent = newDir.parent;

            if (!parent) {
              _context2.next = 12;
              break;
            }

            if (!(newDir !== dir)) {
              _context2.next = 11;
              break;
            }

            if (child) {
              child.parent = newDir;
            }

            _context2.next = 11;
            return parent.put(newDir.parentKey, newDir);

          case 11:
            return _context2.abrupt("return", flatToShard(newDir, parent, threshold, options));

          case 12:
            return _context2.abrupt("return", newDir);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  function flatToShard(_x, _x2, _x3, _x4) {
    return _flatToShard.apply(this, arguments);
  }

  return flatToShard;
}();

function convertToShard(oldDir, options) {
  var newDir, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value2, key, child;

  return _regeneratorRuntime.async(function convertToShard$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          newDir = new DirSharded({
            root: oldDir.root,
            dir: true,
            parent: oldDir.parent,
            parentKey: oldDir.parentKey,
            path: oldDir.path,
            dirty: oldDir.dirty,
            flat: false,
            mtime: oldDir.mtime,
            mode: oldDir.mode
          }, options);
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _context.prev = 3;
          _iterator = _asyncIterator(oldDir.eachChildSeries());

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 7:
          _step = _context.sent;
          _iteratorNormalCompletion = _step.done;
          _context.next = 11;
          return _regeneratorRuntime.awrap(_step.value);

        case 11:
          _value = _context.sent;

          if (_iteratorNormalCompletion) {
            _context.next = 19;
            break;
          }

          _value2 = _value, key = _value2.key, child = _value2.child;
          _context.next = 16;
          return _regeneratorRuntime.awrap(newDir.put(key, child));

        case 16:
          _iteratorNormalCompletion = true;
          _context.next = 5;
          break;

        case 19:
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 25:
          _context.prev = 25;
          _context.prev = 26;

          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
            _context.next = 30;
            break;
          }

          _context.next = 30;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 30:
          _context.prev = 30;

          if (!_didIteratorError) {
            _context.next = 33;
            break;
          }

          throw _iteratorError;

        case 33:
          return _context.finish(30);

        case 34:
          return _context.finish(25);

        case 35:
          return _context.abrupt("return", newDir);

        case 36:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[3, 21, 25, 35], [26,, 30, 34]], Promise);
}